import { render } from "./ScanResultView.vue?vue&type=template&id=2032fa72&scoped=true&lang=true"
import script from "./ScanResultView.vue?vue&type=script&lang=js"
export * from "./ScanResultView.vue?vue&type=script&lang=js"

import "./ScanResultView.vue?vue&type=style&index=0&id=2032fa72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2032fa72"]])

export default __exports__